
export enum PagerLinkType {
    Prev = -1,
    Next = 1
}